import { get } from "lodash";
import each from "lodash/each";
import { Subject } from "rxjs";

import { Constructor } from "../types/constructor";

export interface IDestroyable {
    onDestroy: Subject<void>;
    destroy(): void;
}

export const BaseDestroyableMixin = <TBaseClass extends Constructor<object>>(
    BaseClass: TBaseClass
): TBaseClass & Constructor<IDestroyable> => {

    return class BaseDestroyableExtension extends BaseClass implements IDestroyable {
        public onDestroy: Subject<void> = new Subject<void>();

        public destroy(): void {
            this.onDestroy.next();

            const properties = Object.getOwnPropertyDescriptors(this);

            each(properties, (propDescriptor: PropertyDescriptor, key: string) => {
                const value = get(this, key) as object;
                this.destroyMember(value);
            });
        }

        // NOTE: it's necessary to override it because abstract mixin allow us to do not implement abstract members in TypeScript
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        protected destroyMember(value: object): void {
            throw new Error("Method not implemented.");
        }
    };
};
